import { createAction, props } from '@ngrx/store';

import { SubscribeButtonClickEventType } from './subscribe.models';

export const subscribe = createAction(
  '[Tracking][BAU365] Subscribe button clicked',
  props<SubscribeButtonClickEventType>()
);
